const Main = () => import('../../pages/main')

export default {
	path: '/videoList',
	component: Main,
	meta: {
		sideNav: true
	},
	children: [
		{
			name: 'VideoList',
			path: 'index',
			component: () => import('../../pages/ShortVideo/VideoList'),

			meta: {
				requiresAuth: true,
				hidden: false,
				title: '视频列表',
				icon: 'icon-nav-video',
			}
		}
	]
}
